import exampleApp2Config from './example-app-2/example-2-config';

const applications = {
  'example-app-2': exampleApp2Config
};

export default applications;